import { ExternalLink } from "@octopusdeploy/design-system-components";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
const Onboarding = () => (<OnboardingPage title="There are no audit archives" intro="Audit logs are archived periodically to ensure Octopus operates swimmingly. You can access the archived logs here." learnMore={<>
                <ExternalLink href="ArchivedAuditLogs">Learn more</ExternalLink>
            </>}/>);
export default Onboarding;
